module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAABBUlEQVR42q2T0VHDQAxEV6ngOsAdYDowFSQluIR0gDtJOgAqcDpwqCDpwEkFjx/dICDY5wma0XhO0u2tZK1pwoBG0lpS7aGLpHcz26vEgAro+bKTezxv5kBqYHTvgBRyCWgD6MsUk/x6NcN4cLDmVsHOk1VB+8lZ97eSI7BToQHbX6yAxoObBUDJ72xXIZ7bGUqBzOwi6SzpcaV/sgh09u/Tkta8k48IdPTNXS8gkud5+PlC58OrCwd9Aoap5NxCJuD1z50Lm5311EaJhDXJNe2cPBpgH0Q6uI/h/E0alkEk9ZKSpGczO2YB+0AfvP4q6c3MDlNMxpIhT02/uxsk/IF072Z/AsS7YYZrLXS3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/magnifier-icon.png
// module id = 622
// module chunks = 0 1 2 3 4